<div class="row main-panel px-2" [ngClass]="{ 'centerAlign': centerAlign() }"
  *ngIf="menuCategories && (selectedStoreStatus$ | async) === 'LOADED'">
  <div class="catalog-panel" [ngClass]="{'panelWidth': !basketEnabled}">
    <div class="catalog-content rounded"
      [style.background-image]="getBackgroundImage( (selectedStore$ | async)?.settings?.IMAGE_BACKGROUND )"
      [ngClass]="{'d-none': menuCategories && menuCategories.length <= 0, 'mb-6': !isGoApp && gutterBottom, 'mb-7': isGoApp }"
      [ngStyle]="isMobileApp ? {'padding-bottom':'5vh'}:{}" #catalogContent>
      <ng-container *ngFor="let catItem of menuCategories;">
        <div class="tab-pane-wrapper mb-1"
          *ngIf="catItem.offers && catItem.offers.length > 0 && (!categorySearch || checkCategorySearchFilter(catItem.offers))">
          <div id="category{{catItem.categoryId}}" class="category-tab tab-pane fade in show active pt-0 px-0"
            [ngClass]="{'active-cat': selectedCat === catItem.categoryId, 'collapsable': (selectedStore$ | async)?.settings?.CATALOG_CATEGORIES_COLLAPSE === true, searchEpanded: searchSelectedCatList.includes(catItem.categoryId)}"
            role="tabpanel" aria-labelledby="home-tab">
            <div class="cat-name w-100 d-flex px-2 px-md-3 py-2 py-md-3 font-weight-bold justify-content-between"
              [style.background]="(getBackgroundImage( (selectedStore$ | async)?.settings?.IMAGE_BACKGROUND )) ? '' : '#F2F0EE'"
              [ngClass]="{'theme-light-cat-name-bg-none': getBackgroundImage((selectedStore$ | async)?.settings?.IMAGE_BACKGROUND),
           'theme-light-cat-name-bg-light-grey': !getBackgroundImage((selectedStore$ | async)?.settings?.IMAGE_BACKGROUND)
          }" [style.font-size.rem]="'1'"
              (click)="currentCartStatus === 'LOADED' && onSelectCategory(catItem.categoryId, 'toggle')">
              <div class="catWidth mr-2"
                [ngClass]="{'cattitle-revser': isCategoryAction, 'image-catWidth': getBackgroundImage(catItem.standardImage),}">
                {{catItem.name}}
                <div class="font-size-primary font-weight-normal" [ngClass]="{'mt-2':catItem.shortDescription}">
                  {{catItem.shortDescription}}</div>
              </div>
              <div>
                <div class="category-image float-right border-0"
                  [ngClass]="{'d-none':!getBackgroundImage(catItem.standardImage)}"
                  [style.background-image]="getBackgroundImage(catItem.standardImage)"></div>
              </div>
              <div
                [ngClass]="{'d-none': !(selectedStore$ | async)?.settings?.CATALOG_CATEGORIES_COLLAPSE, 'searchEpanded': searchSelectedCatList.includes(catItem.categoryId)}">
                <ng-container *ngIf="!isCategoryExpanded(catItem.categoryId); else minusIcon">
                  <i class="fa catagory-plus-icon fa-chevron-right m-auto"
                    [ngClass]="{'catagory-plus-icon-no-image':!getBackgroundImage(catItem.standardImage)}"
                    [ngClass]="isCategoryAction ? 'icon-revser-plus' : ''"></i>
                </ng-container>
                <ng-template #minusIcon>
                  <i class="fa catagory-minus-icon fa-chevron-down m-auto"
                    [ngClass]="{'catagory-minus-icon-no-image':!getBackgroundImage(catItem.standardImage)}"
                    [ngClass]="isCategoryAction ? 'icon-revser-minus' : ''"></i>
                </ng-template>
              </div>
            </div>
            <div class="tab-pane-content-wrapper fast">
              <div class="tab-pane-content-row px-sm-3 px-md-2 pb-md-2">
                <ng-container *ngFor="let menuItem of catItem.offers;">
                  <div
                    (click)="currentCartStatus === 'LOADED' && viewProductDetails(menuItem.offerId, catItem.categoryId, menuItem.inStock, menuItem.isExpandable, menuItem.isOrderable, basketEnabled)"
                    class="menu-item d-flex borderBottom justify-content-between position-relative col-md-6 float-left p-0 my-md-1 my-0"
                    [ngClass]="{'discount': menuItem.discount, 'pointer': menuItem.inStock && (menuItem.isExpandable || (basketEnabled && menuItem.isOrderable) || (!basketEnabled && isAdminOrderCaptureUpdate))}"
                    *ngIf="!categorySearch || (menuItem.name?.toLocaleLowerCase().includes(categorySearch.toLocaleLowerCase()))"
                    title="click to add to cart">
                    <div class="d-flex mx-0 mx-md-2 my-0 my-md-1 w-100 order-item"
                      [ngClass]="{'overlay': !menuItem.inStock}" *ngIf="checkOfferInCart(menuItem); let orderItem">
                      <div class="in-cart theme-light-cart" *ngIf="!!orderItem.item"></div>
                      <div class="d-flex flex-fill item-offer flex-column text-unselectable m-2"
                        [ngClass]="{'image-item-offer': menuItem.standardImage}">

                        <div class="item d-flex font-size-primary mr-2 font-weight-bold justify-content-between">
                          <span [innerHtml]="menuItem.name | highlightSearch: categorySearch"
                            class="theme-color-subtitle-2 text-left"></span>
                          <span class="calories-info text-right"
                            *ngIf="isAllergenSelected((menuItem)?.attributeDtos,'CALORIES')"
                            [ngClass]="{'with-image': menuItem.standardImage, 'd-none': !menuItem.standardImage}">
                            <img src="/assets/img/offer-characteristics/Customer/fire.png" alt="">
                            {{isAllergenSelected((menuItem)?.attributeDtos,'CALORIES')}} kcal
                          </span>
                        </div>

                        <div class="description d-flex mr-1 text-break font-size-secondary"
                          *ngIf="menuItem.shortDescription">{{ menuItem.shortDescription }}
                        </div>

                        <app-offer-price [menuItem]="menuItem" [locale]="selectedStoreLocale"
                          [currency]="selectedStoreCurrency" [currencySymbol]="selectedStoreCurrencySymbol">
                        </app-offer-price>

                        <app-allergens [attributes]="menuItem.attributeDtos"
                          [isAdminOrderCaptureUpdate]="isAdminOrderCaptureUpdate">
                        </app-allergens>

                      </div>
                      <div class="d-flex my-2 mr-2">
                        <span class="calories-info" *ngIf="isAllergenSelected((menuItem)?.attributeDtos,'CALORIES')"
                          [ngClass]="{ 'without-image': !menuItem.standardImage, 'd-none': menuItem.standardImage}">
                          <img src="/assets/img/offer-characteristics/Customer/fire.png" alt="">
                          {{isAllergenSelected((menuItem)?.attributeDtos,'CALORIES')}} kcal
                        </span>
                        <div class="p-1" id="plus-minus-icon"
                          [style.background-image]="getBackgroundImage(menuItem.standardImage)"
                          [ngClass]="{'offer-image': menuItem.standardImage, 'offer-actions-no-image': !menuItem.standardImage && isAllergenSelected((menuItem)?.attributeDtos,'CALORIES')}"
                          (click)="onOfferImageClick($event, menuItem)">
                          <app-offer-actions [offer]="menuItem" [cartItems]="getCartItems(menuItem)"
                            [currentCartStatus]="currentCartStatus" [itemAddedToCart]="itemAddedToCart"
                            [decreaseItemQty]="decreaseItemQty" [basketEnabled]="basketEnabled"
                            [orderingEnabled]="orderingEnabled" [size]="'small'">
                          </app-offer-actions>
                        </div>
                      </div>
                    </div>
                  </div>
                </ng-container>
              </div>
            </div>
          </div>
        </div>
      </ng-container>
    </div>
    <!-- PAY ONLINE BUTTON -->
    <div *ngIf="showPayOnlineButton && totalValue === 0 && cartItems?.length === 0"
      class="basket-container d-none d-xl-block pb-2 pt-1 payonline-container"
      [ngStyle]="{'bottom.px': cookieBarHeight}">
      <div class="menu-category-container pay-button-container d-block"
        [ngClass]="{'basket-disabled': (!basketEnabled && !isAdminOrderCaptureUpdate)}">
        <div class="basket-content">
          <div class="empty-cart" *ngIf="!cartItems || !cartItems.length">
            <div class="basket-footer" *ngIf="showPayOnlineButton">
              <a class="button dark d-block text-center py-3 mx-2 mt-2 font-size-primary text-unselectable"
                (click)="payOnline()">
                {{'public.standalonepayment.paymentpage.title' | translate}}
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="cart-panel d-none d-xl-block" *ngIf="menuCategories && menuCategories.length > 0">
    <div class="cart-content" [style.top.px]="contentHeaderHeight" #cartContent>
      <div class="basket-container"
        *ngIf="(basketEnabled || isAdminOrderCaptureUpdate ) && !!menuCategories && (selectedStoreStatus$ | async) === 'LOADED' && selectedCatalog !== -1">
        <div class="basket pl-4">
          <div class="basket-content rounded">
            <div class="empty-cart" *ngIf="!cartItems || !cartItems.length">
              <i class="fa-solid fa-basket-shopping mx-auto my-5 fs-120"></i>
              <div class="px-3 description text-center font-size-primary mb-4">
                {{'public.dashboard.basket.emptyCart' | translate}}
              </div>
            </div>
            <div class="cart-items" *ngIf="cartItems && cartItems.length">
              <div
                class="basket-header font-size-header p-3 text-center font-weight-bold theme-light theme-color-header">
                {{'public.checkout.yourOrder' | translate}}
              </div>
              <div class="basket-body p-2 mt-2 overflow-auto"
                [style.max-height]="'calc(100vh - 200px - '+ cartContentPosition + 'px)'">
                <ng-container *ngFor="let cartItem of cartItems; index as i;">
                  <div class="p-1 d-flex flex-row align-items-start cartItem mb-2" *ngIf="cartItem.quantity > 0"
                    (click)="viewOrderItemDetails(cartItem)">
                    <div class="d-flex align-items-start" *ngIf="cartItem.hierarchyLevel === 'PARENT' || cartItem.hierarchyLevel === 'GIFT_CARD'">
                      <div class="decrement container-theme-light-icons" (click)="onDecreaseItemQty($event, cartItem)">
                        <i class="fa fa-minus m-auto"></i>
                      </div>
                      <div class="value mx-2 font-size-primary theme-color-text">
                        {{cartItem.quantity}}</div>
                      <div class="increment container-theme-light-icons" (click)="onIncreaseItemQty($event, cartItem)">
                        <i class="fa fa-plus m-auto"></i>
                      </div>
                    </div>
                    <div class="d-block mx-2 w-75">
                      <!-- Item Name -->
                      <div class="font-size-primary theme-color-text font-weight-bold">
                        {{cartItem.itemName}}
                        <span class="d-inline-block"
                          [ngClass]="{'d-none': (!checkoutService.isShowParentItemPrice(cartItem) || cartItem.offerPrice === 0)}">
                          ( {{ cartItem.offerPrice | formatPrice:
                          selectedStoreLocale:selectedStoreCurrency:selectedStoreCurrencySymbol
                          }} )
                          <span class="ml-3 edit-icon">
                            <i class="fa fas fa-pen theme-color-header"></i>
                          </span>
                        </span>
                      
                      </div>
                      <!-- Item Description -->
                      <div class="child-order-item p-0 mb-0 font-size-primary text-unselectable"
                        *ngIf="cartItem.priceDescription">
                        {{ cartItem.priceDescription }}
                      </div>
                      <!-- Item Discount -->
                      <ng-container *ngIf="cartItem.discountType">
                        <ng-template
                          *ngIf="cartItem.discountType === 'MONETARY'; then showMonetaryDiscount; else showPercentileDiscount">
                        </ng-template>
                        <ng-template #showMonetaryDiscount>
                          <div class="discount p-0 mb-0 font-size-primary text-unselectable"
                            *ngIf="cartItem.discountValue > 0">
                            {{'public.global.discount' | translate}}
                            <ng-container *ngIf="cartItem.discountValue > 0">
                              (- {{ cartItem.discountValue | formatPrice:
                              selectedStoreLocale:selectedStoreCurrency:selectedStoreCurrencySymbol
                              }})
                              <i class="fa-solid fa-tag mt-1 ml-2 fs-12 discount-value"></i>
                            </ng-container>
                          </div>
                        </ng-template>
                        <ng-template #showPercentileDiscount>
                          <div class="discount p-0 mb-0 font-size-primary text-unselectable"
                            *ngIf="cartItem.discountValue > 0">
                            {{'public.global.discount' | translate}} {{
                            cartItem.discountValue }}%
                            <i class="fa-solid fa-tag mt-1 ml-2 fs-12 discount-value"></i>
                            <ng-container *ngIf="(cartItem.offerPrice * cartItem.discountValue / 100) > 0">
                              (- {{ cartItem.offerPrice * cartItem.discountValue / 100 |
                              formatPrice:
                              selectedStoreLocale:selectedStoreCurrency:selectedStoreCurrencySymbol
                              }} )
                            </ng-container>
                          </div>
                        </ng-template>
                      </ng-container>
                      <div class="child-order-item p-0 mb-0 font-size-primary text-unselectable"
                        *ngFor="let childOrderItem of cartItem.childOrderItems">
                        {{ childOrderItem.quantity > 1 ? childOrderItem.quantity + ' x' : '' }}
                        {{
                        childOrderItem.itemName }}
                        <span *ngIf="childOrderItem.offerPrice && childOrderItem.offerPrice !== 0">
                          ( {{ childOrderItem.offerPrice | formatPrice:
                          selectedStoreLocale:selectedStoreCurrency:selectedStoreCurrencySymbol
                          }} )
                        </span>
                      </div>
                      <div *ngIf="cartItem.wishTime"
                        class="d-flex pt-1 px-0 space-nowrap theme-color-date-text font-size-primary">
                        {{ isTimeShowDisabled() ? '' : cartItem.wishTime | formattedTime:
                        selectedStore?.settings?.TIME_FORMAT_SELECTION : selectedStore?.locale }}
                        {{cartItem.wishTime | localizedDate:'ddd DD MMM':(userLang$ | async):browserTimeZone | async }}
                      </div>
                    </div>
                    <div class="ml-auto text-right w-25"
                      *ngIf="(cartItem.hierarchyLevel === 'PARENT' || cartItem.hierarchyLevel === 'RULE' || cartItem.hierarchyLevel === 'GIFT_CARD') && cartItem.totalNonDiscountedPrice != 0">
                      <div class="font-size-primary text-unselectable"
                        [ngClass]="{'striked': cartItem.discountType && cartItem.discountValue > 0}">
                        {{ cartItem.totalNonDiscountedPrice | formatPrice:
                        selectedStoreLocale:selectedStoreCurrency:selectedStoreCurrencySymbol }}
                      </div>
                      <div class="discount-value font-size-primary text-unselectable"
                        *ngIf="cartItem.discountType && cartItem.discountValue > 0">
                        {{ cartItem.totalDiscountedPrice | formatPrice:
                        selectedStoreLocale:selectedStoreCurrency:selectedStoreCurrencySymbol }}
                      </div>
                    </div>
                  </div>

                </ng-container>
              </div>
              <div class="basket-footer theme-color-text">
                <div class="d-flex flex-row mx-2 mb-2 p-1" *ngIf="checkoutService.shouldDisplayTotal()">
                  <div class="total flex-fill font-size-primary text-unselectable font-weight-bold" id="total-checkout">
                    {{'public.checkout.total' | translate}}
                  </div>
                  <div class="price text-right font-size-primary text-unselectable font-weight-bold">
                    {{totalValue | formatPrice:
                    selectedStoreLocale:selectedStoreCurrency:selectedStoreCurrencySymbol }}
                  </div>
                </div>
                <span
                  class="button d-flex justify-content-center align-items-center text-center font-size-primary text-unselectable w-100"
                  (click)="currentCartStatus === 'LOADED' && onViewOrder($event)">
                  {{'public.dashboard.basket.proceed' | translate}}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>